import {
  CreateLocationAliasRequest,
  ListLocationAliasesResponse,
  LocationAlias,
  UpdateLocationAliasRequest,
} from 'api/models/NameAlias';
import ApiClientBase from './ApiClientBase';

class NameAliasesEndpoint extends ApiClientBase {
  apiUri = '/api/v2/hospitals/name-alias';

  addHospitalNameAlias({ hospitalId, alias }: { hospitalId: string; alias: string }) {
    return this.apiCall(`/`, 'put', {
      type: 'location',
      id: hospitalId,
      alias,
    });
  }

  addSurgeonNameAlias({ surgeonId, alias }: { surgeonId: string; alias: string }) {
    return this.apiCall(`/`, 'put', {
      type: 'surgeon',
      id: surgeonId,
      alias,
    });
  }

  listLocationAliases() {
    return this.apiCall<ListLocationAliasesResponse>('/');
  }

  createLocationAlias(request: CreateLocationAliasRequest) {
    return this.apiCall<LocationAlias>('/', 'post', request);
  }

  updateLocationAlias(aliasId: string, request: UpdateLocationAliasRequest) {
    return this.apiCall<LocationAlias>(`/${aliasId}/`, 'patch', request);
  }

  deleteLocationAlias(aliasId: string) {
    return this.apiCall<void>(`/${aliasId}/`, 'delete');
  }
}

const nameAliases = new NameAliasesEndpoint();

export default nameAliases;
